import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { Form, Combo, SearchBox } from 'fw/forms';
import { Button } from 'fw/components';
import * as API from 'modules/app/API'

const LogTypes = {
  "1": "ALL",
  "2": "Debug",
	"3": "Error",
  "4": "Information",
  "5": "Warning"
};

class Search extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
          form: {
            type: "ALL",
            presetId: "1",
						traceValue: "",
          }
        };
    }

    onSubmit = (e) => {
        e.preventDefault();
        this.props.onSearch(this.state.form);
    }

    onChange = (form, callback) => {
        this.setState({ form }, callback);
    }

    componentDidMount() {
        // Execute the search at page load
        this.props.onSearch(this.state.form);
    }

    search = () => {
        this.props.onSearch(this.state.form);
    }

    searchLoader = () => {
      return {
          url: API.Search.url('/suggest'),
          params: {
              type: 'logevent'
          }
      }
    }

    render() {
        return (
            <Form
                onSubmit={this.onSubmit}
                onChange={this.onChange}
                values={this.state.form}>
                <Row>
                  <Col md={4}>
                    <Combo items={LogTypes} name="presetId" label="type" />
                  </Col>
									<Col md={4}>
                    <SearchBox placeholder="X-PSX-TRACE" name="traceValue" loader={this.searchLoader} />
                  </Col>
                  <Col md={4}>
                    <Button id="btnSubmit" type="submit" bsStyle="primary">Search</Button>
                  </Col>
                </Row>
            </Form>
        )
    }
}

export default Search;



// WEBPACK FOOTER //
// ./src/areas/admin/console/logs/Search.js